import React, { useState } from 'react';
import PrescriptionContainer from './PrescriptionContainer';
import { PrescriptionJobStrategyProvider } from '../Prescription/PrescriptionJobStrategyContext';
import type { AnyPrescriptionJobStrategy } from '../Prescription/PrescriptionJobStrategy';

const PrescriptionContainerWithStrategy = () => {
  const [prescriptionJobStrategy, setPrescriptionJobStrategy] =
    useState<AnyPrescriptionJobStrategy | null>(null);

  return (
    <PrescriptionJobStrategyProvider value={{ prescriptionJobStrategy }}>
      <PrescriptionContainer setPrescriptionJobStrategy={setPrescriptionJobStrategy} />
    </PrescriptionJobStrategyProvider>
  );
};

export default PrescriptionContainerWithStrategy;
